import { Badge, type BadgeProps } from '@components/ui/badge';
import { ArchiveIcon, CheckCircle2Icon, FileEditIcon, ScaleIcon } from 'lucide-react';

type StudyStatusValue = 'ARCHIVED' | 'APPROVED' | 'DRAFT' | 'PROPOSED';

const statusVariants: Record<StudyStatusValue, BadgeProps['variant']> = {
  ARCHIVED: 'status-archived',
  APPROVED: 'status-approved',
  DRAFT: 'status-draft',
  PROPOSED: 'status-proposed',
};

const statusLabels: Record<StudyStatusValue, string> = {
  ARCHIVED: 'Archived',
  APPROVED: 'Approved',
  DRAFT: 'Draft',
  PROPOSED: 'Proposed',
};

const statusIcons: Record<StudyStatusValue, React.ReactNode> = {
  ARCHIVED: <ArchiveIcon className="size-3" />,
  APPROVED: <CheckCircle2Icon className="size-3" />,
  DRAFT: <FileEditIcon className="size-3" />,
  PROPOSED: <ScaleIcon className="size-3" />,
};

type StudyStatusBadgeProps = {
  showIcon?: boolean;
  size?: BadgeProps['size'];
  status: StudyStatusValue;
};

/**
 * Standardized study lifecycle badge. Used across /studies, /meia, and any
 * campaign view that surfaces a study's status. Colors follow the shared
 * `status-*` Badge variants so DRAFT/PROPOSED/APPROVED/ARCHIVED stay
 * consistent with CampaignStatusBadge and the prototype palette.
 */
export const StudyStatusBadge: React.FC<StudyStatusBadgeProps> = (props) => {
  const { showIcon = true, size = 'xs', status } = props;

  return (
    <Badge
      size={size}
      variant={statusVariants[status]}
    >
      {showIcon && statusIcons[status]}
      {statusLabels[status]}
    </Badge>
  );
};
